import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/listing/actionTypes';

import { save } from './utils';

export default function* listenSave() {
  yield takeEvery(actionTypes.SAVE, save);
}
